export const AC = {
  nav: "nav-access-control",
  page: "access-control-page",
  title: "access-control-title",
  tabDefaults: "access-control-tab-defaults",
  tabUsers: "access-control-tab-users",
  tabAudit: "access-control-tab-audit",
  userClassSelect: "access-control-user-class",
  employeeSelect: "access-control-employee",
  employeeCard: "access-control-employee-card",
  employeeName: "access-control-employee-name",
  employeeUsername: "access-control-employee-username",
  employeeClass: "access-control-employee-class",
  employeeRole: "access-control-employee-role",
  employeeStatus: "access-control-employee-status",
  matrix: "access-control-matrix",
  mainMatrix: "access-control-main-matrix",
  hierarchy: "access-control-hierarchy",
  saveDefaults: "access-control-save-defaults",
  saveUser: "access-control-save-user",
  resetUser: "access-control-reset-user",
  resetDialog: "access-control-reset-dialog",
  resetConfirm: "access-control-reset-confirm",
  resetCancel: "access-control-reset-cancel",
  workspaceModule: "access-control-workspace-module",
  workspacePermissions: "access-control-workspace-permissions",
  roleDefinitions: "access-control-role-definitions",
  roleDefinitionsDialog: "access-control-role-definitions-dialog",
  userPermissions: "access-control-user-permissions",
  preferredPreferences: "access-control-preferred-preferences",
  permissionGuide: "access-control-permission-guide",
  resetPermissions: "access-control-reset-permissions",
  cancelPermissions: "access-control-cancel-permissions",
  savePermissions: "access-control-save-permissions",
};
